import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import VivahLogo from './VivahLogo';
import './Navbar.css';

const NAVS = {
  consult: { label:'Marriage Consultation', cls:'tc', links:[
    {to:'/consultation',end:true,label:'Matches'},{to:'/consultation/about',label:'About Us'},
    {to:'/consultation/payment',label:'Payment'},{to:'/consultation/profile',label:'My Profile'},{to:'/contact',label:'Contact'}]},
  decor:   { label:'Wedding Decor', cls:'td', links:[
    {to:'/decor',end:true,label:'About'},{to:'/decor/catalog',label:'Catalog'},
    {to:'/decor/quote',label:'Get Quote'},{to:'/decor/booking',label:'Booking'},{to:'/contact',label:'Contact'}]},
  catering:{ label:'Wedding Catering', cls:'ts', links:[
    {to:'/catering',end:true,label:'About'},{to:'/catering/team',label:'Our Team'},
    {to:'/catering/menu',label:'Menu'},{to:'/catering/quote',label:'Get Quote'},
    {to:'/catering/booking',label:'Booking'},{to:'/contact',label:'Contact'}]},
};

export default function Navbar({ module }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const nav = module ? NAVS[module] : null;
  return (
    <nav className="navbar">
      <span className="nb" onClick={() => navigate('/')}>
        <VivahLogo />
      </span>
      <div className="nl">
        {!module && (<>
          <NavLink className={({isActive})=>'nl'+( isActive?' a':'')} to="/consultation">Matrimony</NavLink>
          <NavLink className={({isActive})=>'nl'+( isActive?' a':'')} to="/decor">Decor</NavLink>
          <NavLink className={({isActive})=>'nl'+( isActive?' a':'')} to="/catering">Catering</NavLink>
        </>)}
        {nav && (<>
          <span className={`nt ${nav.cls}`}>{nav.label}</span>
          {nav.links.map(l=>(
            <NavLink key={l.to} end={l.end} to={l.to}
              className={({isActive})=>`nl ${nav.cls}${isActive?' a':''}`}>{l.label}</NavLink>
          ))}
          {module==='consult' && (user
            ? <button className="nl" onClick={async()=>{await logout();navigate('/');}}>Logout</button>
            : <NavLink className={({isActive})=>'nl'+(isActive?' a':'')} to="/consultation/login">Login</NavLink>)}
          <button className="nb2" onClick={()=>navigate('/')}>← Home</button>
        </>)}
      </div>
    </nav>
  );
}
